import React, { useState } from "react";
import Chart from "../../../GlobalComponents/Chart/Chart";
import PortalBTCWrap from "../PortalBTCWrap/PortalBTCWrap";
import SingleReport from "../SingleReport/SingleReport";

const PortalRightSection = () => {
  const [data, setData] = useState([
    { red: true, title: "Short" },
    { red: false, title: "long" },
    { red: true, title: "Short" },
    { red: false, title: "long" },
    { red: true, title: "Short" },
  ]);
  return (
    <div className="bg-main-black">
      <button className="h-[40px] rounded-t-[5px] bg-main-green text-res-sm text-main-black w-full font-semibold">
        Preview
      </button>
      <div className="flex md:flex-row flex-col mt-[23px] gap-[7px]">
        <div className="md:min-w-[208px] md:max-w-[208px]">
          <PortalBTCWrap></PortalBTCWrap>
        </div>
        <div className="w-full">
          <Chart className="h-[212px] w-full"></Chart>
        </div>
      </div>
      <div className="mt-[34px] mb-[42px]">
        <button className="h-[40px]   bg-main-green text-res-sm text-main-black w-full font-semibold">
          Posts & Reports
        </button>
      </div>
      <div className="flex flex-col gap-[19px] px-[20px] pb-[33px] ">
        {data.map((single, i) => (
          <SingleReport
            i={i}
            setData={setData}
            key={i}
            {...single}
          ></SingleReport>
        ))}
      </div>
    </div>
  );
};

export default PortalRightSection;
